import { render, staticRenderFns } from "./selected.vue?vue&type=template&id=587727f6&scoped=true&"
import script from "./selected.vue?vue&type=script&lang=js&"
export * from "./selected.vue?vue&type=script&lang=js&"
import style0 from "./selected.vue?vue&type=style&index=0&id=587727f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587727f6",
  null
  
)

export default component.exports